import { useCallback, useState } from "react";

export function useTableSort(
  initialSortBy,
  initialSortOrder = "asc"
) {
  const [sortBy, setSortBy] =
    useState(initialSortBy);

  const [sortOrder, setSortOrder] =
    useState(
      initialSortOrder === "desc"
        ? "desc"
        : "asc"
    );

  const toggleSort = useCallback((field) => {
    setSortBy((currentField) => {
      if (currentField === field) {
        setSortOrder((currentOrder) =>
          currentOrder === "asc"
            ? "desc"
            : "asc"
        );

        return currentField;
      }

      setSortOrder("asc");
      return field;
    });
  }, []);

  return {
    sortBy,
    sortOrder,
    toggleSort,
  };
}
